import { LocaleMessageObject } from "vue-i18n";
import i18n from "@/i18n";
import { tenantTranslationsUrl, translationsUrl } from "@/services/apiService";

export const getLocale = (loc: string): string => {
  // let loc = navigator.language || 'en-US'
  switch (loc) {
    case "zh":
    case "zh-CN":
    case "zh-Hans":
    case "zh-Hans-CN":
    case "zh-Hans-SG":
    case "zh-Hans-MO":
    case "zh-Hans-HK":
      loc = "zh-Hans";
      break;
    case "zh-TW":
    case "zh-Hant":
    case "zh-Hant-TW":
    case "zh-Hant-MO":
    case "zh-Hant-HK":
      loc = "zh-Hant";
      break;
  }

  if (loc.split("-")[0] == "it") loc = "it-IT";
  if (loc.split("-")[0] == "en") loc = "en-US";

  return loc;
};

const fetchTranslations = async (
  lang: string
): Promise<LocaleMessageObject> => {
  const url = `${translationsUrl()}/${lang}.json`;
  return fetchRemoteTranslations(url);
};

const fetchTenantTranslations = async (
  lang: string
): Promise<LocaleMessageObject> => {
  const url = `${tenantTranslationsUrl()}/${lang}.json`;
  return fetchRemoteTranslations(url);
};

const fetchRemoteTranslations = async (
  url: string
): Promise<LocaleMessageObject> => {
  // "no-cache" still uses the HTTP cache but always revalidates with the
  // server (ETag/304): without it the browser's heuristic caching can serve
  // a stale catalogue for hours after a Tolgee publish.
  const response = await fetch(url, { cache: "no-cache" });
  const json = await response.json();
  return json;
};

/**
 * True when the translations are served next to the app (relative URL),
 * i.e. the on-prem bundle that snapshots Tolgee at build time. They can
 * then be loaded even when external services are excluded.
 */
export const translationsAreLocal = (): boolean =>
  translationsUrl().startsWith("/");

export const applyRemoteTranslations = async (): Promise<void> => {
  if (!translationsUrl()) return;
  const locale = getLocale(i18n.locale);
  const messages = await fetchTranslations(locale);
  i18n.setLocaleMessage(i18n.locale, messages);
  if (!tenantTranslationsUrl()) return;
  try {
    const tenantMessages = await fetchTenantTranslations(locale);
    i18n.mergeLocaleMessage(i18n.locale, tenantMessages);
  } catch (e) {
    // Tenant overrides are optional: a missing file must not break the catalogue already applied.
    console.warn("tenant translations not available, skipping", e);
  }
};
